import { gql } from 'apollo-boost';


export const graphqlSchema = {
    PROFILE: {
        me: gql`
        query getMe{
            me {
                amazonProfile {
                    _id
                    mwsSelledId
                    companyName
                    cnktId
                    linkerId
                    authToken
                    email
                    emailValid
                    createdAt
                    billGlobalDay
                    billGlobalDayEnabled
                    noGlobalBeforeTS
                    defaultClaveSatProdServ
                    defaultUnidadSat
                    lastGlobalBill
                    sendOnShipping
                    selfBillingEnabled
                    billDayLimit
                    billDayLimitParam
                    billDayLimitEnabled
                    clusterManaged
                    spAccessLastGrantFail
                    excludeBusinessOrders
                }
                fiscalpopProfile {
                    rfc
                    regimenFiscal
                    nombre
                    isProduction
                    authToken
                    lugarExpedicion
                    logoUrl
                }
                fiscalpopProfileStatus {
                    authToken
                    modulusMatch
                    cerModulus
                    cerNumber
                    notAfter
                    notBefore
                    keyModulus
                }
                billing {
                    userId
                    lastPayment
                    lastPaymentId
                    balance
                    enabled
                    isClusterType
                    clusterName
                }
                notify {
                    selfBilling
                }
            }
        }`,
        login: gql`
        mutation Login($login:AccountLogin!) {
            login(login: $login){
                amazonProfile {
                    _id
                    mwsSelledId
                    companyName
                    cnktId
                    linkerId
                    authToken
                    email
                    emailValid
                    createdAt
                    billGlobalDay
                    billGlobalDayEnabled
                    noGlobalBeforeTS
                    defaultClaveSatProdServ
                    defaultUnidadSat
                    lastGlobalBill
                    sendOnShipping
                    selfBillingEnabled
                    billDayLimit
                    billDayLimitParam
                    billDayLimitEnabled
                    clusterManaged
                    spAccessLastGrantFail
                    excludeBusinessOrders
                }
                token
            }
        }`,
        passwordReset: gql`
        mutation PasswordReset($token:String!, $newPassword: String!) {
            passwordReset(token: $token, newPassword: $newPassword){
                amazonProfile {
                    _id
                    mwsSelledId
                    companyName
                    cnktId
                    linkerId
                    authToken
                    email
                    emailValid
                    createdAt
                    billGlobalDay
                    billGlobalDayEnabled
                    noGlobalBeforeTS
                    defaultClaveSatProdServ
                    defaultUnidadSat
                    lastGlobalBill
                    sendOnShipping
                    selfBillingEnabled
                    billDayLimit
                    billDayLimitParam
                    billDayLimitEnabled
                    clusterManaged
                    spAccessLastGrantFail
                    excludeBusinessOrders
                }
                token
            }
        }`,
        requestPasswordReset: gql`
        mutation RequestPasswordReset($email: String!){
            requestPasswordReset(email:$email)
        }`,
        validateToken: gql`
        mutation ValidateToken($token: String!){
            validateToken(token:$token)
        }`,
        acknowledgeNotification: gql`
        mutation AcknowledgeNotification($profileId: String, $property: String){
            acknowledgeNotification(profileId:$profileId, property: $property) {
                selfBilling
            }
        }`,
        SETUP: {
            registerAccount: gql`
            mutation RegisterAccount($account: AccountRegistration!) {
                registerAccount(account: $account){
                    amazonProfile {
                        _id
                        mwsSelledId
                        companyName
                        cnktId
                        linkerId
                        authToken
                        email
                        emailValid
                        createdAt
                        billGlobalDay
                        billGlobalDayEnabled
                        noGlobalBeforeTS
                        defaultClaveSatProdServ
                        defaultUnidadSat
                        lastGlobalBill
                        sendOnShipping
                        selfBillingEnabled
                        billDayLimit
                        billDayLimitParam
                        billDayLimitEnabled
                        clusterManaged
                        spAccessLastGrantFail
                        excludeBusinessOrders
                    }
                    token
                }
            }`,
            setNameRfcChange: gql`
            mutation SetNameRfcChange($nombre: String, $rfc: String){
                setNameRfcChange(nombre: $nombre, rfc: $rfc) {
                    rfc
                    regimenFiscal
                    nombre
                    isProduction
                    authToken
                    lugarExpedicion
                    logoUrl
                }
            }`,
            setLugarExpedicionChange: gql`
            mutation SetLugarExpedicionChange($lugarExpedicion: String!, $regimenFiscal: String!){
                setLugarExpedicionChange(lugarExpedicion: $lugarExpedicion, regimenFiscal: $regimenFiscal) {
                    rfc
                    regimenFiscal
                    nombre
                    isProduction
                    authToken
                    lugarExpedicion
                    logoUrl
                }
            }`,
            setGlobalBillingLimits: gql`
            mutation SetGlobalBillingLimits($billGlobalDay: Float!){
                setGlobalBillingLimits(billGlobalDay: $billGlobalDay){
                    billGlobalDay
                    billDayLimit
                }
            }`,
            setGlobalBillingEnabled: gql`
            mutation SetGlobalBillingEnabled($billGlobalDayEnabled: Boolean!){
                setGlobalBillingEnabled(billGlobalDayEnabled: $billGlobalDayEnabled){
                    billGlobalDayEnabled
                }
            }`,
            setGlobalNoGlobalBefore: gql`
            mutation SetGlobalNoGlobalBefore($noGlobalBeforeTS: Float!){
                setGlobalNoGlobalBefore(noGlobalBeforeTS: $noGlobalBeforeTS){
                    billGlobalDayEnabled
                    noGlobalBeforeTS
                    billGlobalDay
                }
            }`,
            setChargeOnShipping: gql`
            mutation SetChargeOnShipping($charge: Boolean!){
                setChargeOnShipping(charge: $charge){
                    chargeShippingConcept
                }
            }`,
            setLinkTriggerOnShipping: gql`
            mutation SetLinkTriggerOnShipping($sendOnShipping: Boolean!){
                setLinkTriggerOnShipping(sendOnShipping: $sendOnShipping){
                    sendOnShipping
                }
            }`,
            setSelfBillingEnabled: gql`
            mutation SetSelfBillingEnabled($selfBillingEnabled: Boolean!){
                setSelfBillingEnabled(selfBillingEnabled: $selfBillingEnabled){
                    selfBillingEnabled
                }
            }`,
            setSelfBillingLimitsEnabled: gql`
            mutation SetSelfBillingLimitsEnabled($billDayLimitEnabled: Boolean!){
                setSelfBillingLimitsEnabled(billDayLimitEnabled: $billDayLimitEnabled){
                    billDayLimitEnabled
                }
            }`,
            setExcludeBusinessOrders: gql`
            mutation SetExcludeBusinessOrders($excludeBusinessOrders: Boolean!){
                setExcludeBusinessOrders(excludeBusinessOrders: $excludeBusinessOrders){
                    excludeBusinessOrders
                }
            }`,
            setSelfBillingLimits: gql`
            mutation SetSelfBillingLimits($limits: selfBillingLimits!){
                setSelfBillingLimits(limits: $limits){
                    billDayLimitEnabled
                    billDayLimitParam
                    billDayLimit
                }
            }`,
            setSATdefaults: gql`
            mutation SetSATdefaults($defaults: satDefaults!){
                setSATdefaults(defaults: $defaults){
                    defaultClaveSatProdServ
                    defaultUnidadSat
                }
            }
            `,
        },
        ITEMS: {
            setBulkItemBinder: gql`
            mutation SetBulkItemBinder($productIds: [String]!, $binder: ItemBinder!){
                setBulkItemBinder(productIds: $productIds, binder: $binder){
                    productId
                    claveProdServ
                    claveUnidad
                    customized
                    taxes{
                        type
                        tipo
                        tasa
                        cuota
                    }
                }
            }`,
            setItemBinder: gql`
            mutation SetItemBinder($binder: ItemBinder!){
                setItemBinder(binder: $binder){
                    productId
                    claveProdServ
                    claveUnidad
                    customized
                    taxes{
                        type
                        tipo
                        tasa
                        cuota
                    }
                    pedimento
                }
            }`,
            getItemsByName: gql`
                query GetItemsByName($name: String!, $page: Float){
                    getItemsByName(name: $name, page: $page){
                        page
                        pages
                        items {
                            item{
                                id
                                site_id
                                title
                                subtitle
                                seller_id
                                category
                                official_store_id
                                price
                                base_price
                                original_price
                                inventory_id
                                currency_id
                                initial_quantity
                                available_quantity
                                sold_quantity
                                secure_thumbnail
                                permalink
                                pictures {
                                    id
                                    url
                                    secure_url
                                    size
                                    max_size
                                    quality
                                }
                                shipping {
                                    mode
                                    local_pick_up
                                    free_shipping
                                    dimensions
                                    store_pick_up
                                }
                            }
                            binder{
                                claveProdServ
                                claveUnidad
                                customized
                                taxes {
                                    type
                                    tasa
                                    cuota
                                }
                                pedimento
                            }
                        }
                    }
                }
            `,
            getItems: gql`
                query GetItems{
                    getItems{
                        item{
                            _id
                            asin1
                            asin2
                            asin3
                            imageUrl
                            itemName
                            listingId
                            price
                            quantity
                            productId
                            sellerSku
                            status
                        }
                        binder{
                            productId
                            customized
                            claveProdServ
                            claveUnidad
                            taxes {
                                type
                                tasa
                                cuota
                            }
                            pedimento
                        }
                    }
                }
            `,
            getItemStatus: gql`
                query GetItemStatus{
                    getItemStatus{
                        fetchedAt
                        textStatus
                    }
                }
            `,
            getItemsByIds: gql`
                query GetItemsByIds($ids: [String]!){
                    getItemsByIds(ids: $ids) {
                        item{
                            id
                            site_id
                            title
                            subtitle
                            status
                            seller_id
                            category
                            official_store_id
                            price
                            base_price
                            original_price
                            inventory_id
                            currency_id
                            initial_quantity
                            available_quantity
                            sold_quantity
                            secure_thumbnail
                            permalink
                            pictures {
                                id
                                url
                                secure_url
                                size
                                max_size
                                quality
                            }
                            shipping {
                                mode
                                local_pick_up
                                free_shipping
                                dimensions
                                store_pick_up
                            }
                        }
                        binder{
                            claveProdServ
                            claveUnidad
                            customized
                            taxes {
                                type
                                tasa
                                cuota
                            }
                            pedimento
                        }
                    }
                }
            `,
            getCategorization: gql`
            query GetCategorization{
                getCategorization{
                    updatedAt
                    inProgress
                    dictionary{
                        category_id
                        category
                        count
                    }

                }
            }`,
            getItemBinders: gql`
            query GetItemBinders($itemIds: [String]!){
                getItemBinders(itemIds: $itemIds){
                    productId
                    customized
                    claveProdServ
                    claveUnidad
                    profileId
                    taxes {
                        type
                        tipo
                        tasa
                        cuota
                    }
                }
            }`
        },
        ORDERS: {
            ordersFetchProgress: gql`
            subscription OrdersFetchProgress {
                ordersFetchProgress {
                    hasNext
                    fetched
                    cycleOrders {
                        order {
                            PurchaseDate
                            AmazonOrderId
                            OrderStatus
                            IsPrime
                            OrderTotal {
                                Amount
                                CurrencyCode
                            }
                        }
                        binder{
                            orderId
                            billUUID
                            billIsGlobal
                            refundIds
                            mwsSelledId
                            refundBillUUID {
                                uuid
                                refundIds
                            }
                        }
                    }
                }
              }
            `,
            getOrdersStatus: gql`
                query GetOrdersStatus{
                    getOrdersStatus{
                        fetchedAt
                        textStatus
                    }
                }
            `,
            getOrderBinders: gql`
            query GetOrderBinders($orderIds: [String]) {
                getOrderBinders(orderIds: $orderIds) {
                    orderId
                    billUUID
                    billIsGlobal
                    refundIds
                    mwsSelledId
                    refundBillUUID {
                        uuid
                        refundIds
                    }
                }
            }`,
            getOrdersGlobal: gql`
            query GetOrdersGlobal($start: Float, $end: Float) {
                getOrdersGlobal(start: $start, end: $end) {
                    order {
                        LatestShipDate
                        PurchaseDate
                        AmazonOrderId
                        LastUpdateDate
                        IsReplacementOrder
                        OrderStatus
                        NumberOfItemsShipped
                        NumberOfItemsUnshipped
                        SalesChannel
                        PaymentMethod
                        PaymentMethodDetails
                        IsPrime
                        FulfillmentChannel
                        _linkSent
                        OrderTotal {
                            Amount
                            CurrencyCode
                        }
                    }
                    binder{
                        orderId
                        billUUID
                        billIsGlobal
                        refundIds
                        mwsSelledId
                        refundBillUUID {
                            uuid
                            refundIds
                        }
                    }
                    taxing {
                        subtotal
                        taxes {
                            type
                            tasa
                        }
                    }
                }
            }`,
            getOrdersSearch: gql`
            query GetOrdersSearch($search: String) {
                getOrdersSearch(search: $search) {
                    order {
                        LatestShipDate
                        PurchaseDate
                        AmazonOrderId
                        LastUpdateDate
                        IsReplacementOrder
                        OrderStatus
                        NumberOfItemsShipped
                        NumberOfItemsUnshipped
                        SalesChannel
                        PaymentMethod
                        PaymentMethodDetails
                        IsPrime
                        FulfillmentChannel
                        _linkSent
                        OrderTotal {
                            Amount
                            CurrencyCode
                        }
                    }
                    binder{
                        orderId
                        billUUID
                        billIsGlobal
                        refundIds
                        mwsSelledId
                        refundBillUUID {
                            uuid
                            refundIds
                        }
                    }
                }
            }`,
            getOrders: gql`
            query GetOrders($start: Float, $end: Float, $page: Float) {
                getOrders(start: $start, end: $end, page: $page) {
                    pages
                    page
                    orders {
                        order {
                            LatestShipDate
                            PurchaseDate
                            AmazonOrderId
                            LastUpdateDate
                            IsReplacementOrder
                            OrderStatus
                            NumberOfItemsShipped
                            NumberOfItemsUnshipped
                            SalesChannel
                            PaymentMethod
                            PaymentMethodDetails
                            IsPrime
                            FulfillmentChannel
                            _linkSent
                            OrderTotal {
                                Amount
                                CurrencyCode
                            }
                        }
                        binder{
                            orderId
                            billUUID
                            billIsGlobal
                            refundIds
                            mwsSelledId
                            refundBillUUID {
                                uuid
                                refundIds
                            }
                        }
                    }
                }
            }`,
            getOrderById: gql`
            query GetOrderById($id: String) {
                getOrderById(id: $id) {
                    order {
                        order {
                            LatestShipDate
                            PurchaseDate
                            AmazonOrderId
                            LastUpdateDate
                            IsReplacementOrder
                            OrderStatus
                            NumberOfItemsShipped
                            NumberOfItemsUnshipped
                            SalesChannel
                            PaymentMethod
                            PaymentMethodDetails
                            IsPrime
                            FulfillmentChannel
                            OrderTotal {
                                Amount
                                CurrencyCode
                            }
                            BuyerInfo {
                                BuyerEmail
                                BuyerName
                            }
                            _linkSent
                        }
                        binder{
                            orderId
                            billUUID
                            billIsGlobal
                            refundIds
                            mwsSelledId
                            refundBillUUID {
                                uuid
                                refundIds
                            }
                        }
                    }
                    products {
                        item {
                            ASIN
                            OrderItemId
                            SellerSKU
                            Title
                            QuantityOrdered
                            QuantityShipped
                            ItemPrice {
                                Amount
                                CurrencyCode
                            }
                            ShippingPrice {
                                Amount
                                CurrencyCode
                            }
                        }
                        binder {
                            productId
                            customized
                            claveProdServ
                            claveUnidad
                            taxes {
                                type
                                tasa
                                cuota
                            }
                        }
                    }
                }
            }`,
        },
        REPORTS: {
            reportBuildProgress: gql`
            subscription reportBuildProgress {
                reportBuildProgress {
                    _id
                    working
                    hasStarted
                    dataUrl
                    ordersFetchProgress {
                        hasNext
                        fetched
                    }
                    ordersBindedProgress{
                        hasNext
                        fetched
                    }
                    productsProgress{
                        hasNext
                        fetched
                    }
                    billsProgress{
                        hasNext
                        fetched
                    }
                }
              }
            `,
            buildReport: gql`
                mutation BuildReport($startDate: String!, $endDate: String!, $template: ReportTemplateInput!){
                    buildReport(startDate: $startDate, endDate: $endDate,template: $template)
                }
            `,
            getReportJob: gql`
                query GetReportJob($reportid: String){
                    getReportJob(reportId: $reportid){
                        _id
                        createdAt
                        working
                        hasStarted
                        dataUrl
                        startDate
                        endDate
                        templateIs {
                            userId
                            name
                            description
                            facturaFields
                            pedidoFields
                            shippingFields
                        }
                    }
                }`,
            getReportJobs: gql`
                query GetReportJobs{
                    getReportJobs{
                        _id
                        createdAt
                        working
                        hasStarted
                        dataUrl
                        startDate
                        endDate
                        templateIs {
                            userId
                            name
                            description
                            facturaFields
                            pedidoFields
                            shippingFields
                        }
                    }
                }`,
            saveReportTemplate: gql`
                mutation SaveReportTemplate($template: ReportTemplateInput!){
                    saveReportTemplate(template: $template){
                        userId
                        name
                        description
                        facturaFields
                        pedidoFields
                        shippingFields
                    }
                }
            `,
            getTemplateReports: gql`
                query GetTemplateReports{
                    getTemplateReports{
                        userId
                        name
                        description
                        facturaFields
                        pedidoFields
                        shippingFields
                    }
                }
            `
        }
    },
    FISCALPOP: {
        CFDI: {
            setRefundToStamp: gql`
                mutation SetRefundToStamp($cfdi: FiscalpopBill!, $refundIds: [String]!, $orderId: String!){
                    setRefundToStamp(cfdi: $cfdi, refundIds: $refundIds, orderId:$orderId){
                        orderId
                        billUUID
                        billIsGlobal
                        refundBillUUID {
                            uuid
                            refundIds
                        }
                        refundIds
                        mwsSelledId
                    }
                }
            `,
            setBillToStamp: gql`
                mutation SetBillToStamp($cfdi: FiscalpopBill!, $orderId: String!, $refundIds: [String]){
                    setBillToStamp(cfdi: $cfdi, orderId: $orderId, refundIds: $refundIds){
                        orderId
                        billUUID
                        billIsGlobal
                        refundBillUUID {
                            uuid
                            refundIds
                        }
                        refundIds
                        mwsSelledId
                    }
                }
            `,
            setGlobalBillToStamp: gql`
                mutation SetGlobalBillToStamp($cfdi: FiscalpopBill!, $orderIds: [String]!, $lastDate: Float){
                    setGlobalBillToStamp(cfdi: $cfdi, orderIds: $orderIds, lastDate: $lastDate){
                        UUID
                    }
                }
            `,
            setBillToCancel: gql`
            mutation SetBillToCancel($uuid: String!){
                setBillToCancel(uuid: $uuid){
                    folios {
                        estatus
                        uuid
                    }
                }
            }
            `,
            setOrderToCancel: gql`
            mutation SetOrderToCancel($orderId: String!){
                setOrderToCancel(orderId: $orderId){
                    canceled
                    refundUUID
                }
            }
            `,
        },
        REGIMEN: {
            getRegimenFiscal: gql`
                query GetRegimenFiscal{
                    getRegimenFiscal{
                        clave
                        descripcion
                    }
                }
            `
        },
        SETUP: {
            setFiscalpopClient: gql`
            mutation SetFiscalpopClient($client: FiscalpopClient!){
                setFiscalpopClient(client: $client){
                    rfc
                    regimenFiscal
                    nombre
                    lugarExpedicion
                }
            }`,
        },
        SUPPORT: {
            sendSupportEmail: gql`
            mutation SendSupportEmail($support: FiscalpopSupport!){
                sendSupportEmail(support: $support) {
                    success
                }
            }`
        },
        NOTIFICATONS: {
            getNewsWallConfirmed: gql`
            query GetNewsWallConfirmed{
                getNewsWallConfirmed {
                    _id
                    profileId
                    newsId
                }
            }
            `,
            saveNewsWallConfirmed: gql`
            mutation SaveNewsWallConfirmed($newsId: String!){
                saveNewsWallConfirmed(newsId: $newsId) {
                    _id
                    profileId
                    newsId
                }
            }`
        },
        PAYMENTS: {
            paymentMovements: gql`
            subscription PaymentMovements {
                paymentMovements {
                    orderId
                    billingId
                    amount
                    paid
                }
              }
            `,
        },
    },
    CONEKTA: {
        ORDERS: {
            getPaymentOrders: gql`
            query GetPaymentOrders {
                getPaymentOrders {
                    type
                    orderId
                    userId
                    amount
                    paid
                    currency
                    status
                    createdAt
                    expired
                    invoiceUUID
                }
            }`
        },
        SPEI: {
            requestSpeiPayment: gql`
            mutation RequestSpeiPayment($amount: Float!) {
                requestSpeiPayment(amount: $amount){
                    id
                    bank
                    clabe
                    amount
                    currency
                    order
                    quantity
                }
            }`
        },
        CARDS: {
            requestCardPayment: gql`
            mutation RequestCardPayment($amount: Float!, $sourceid: String!) {
                requestCardPayment(amount: $amount, sourceid: $sourceid) {
                    type
                    orderId
                    userId
                    amount
                    paid
                    currency
                    status
                    createdAt
                }
            }`,
            getCardPayments: gql`
                query GetCardPayments {
                    getCardPayments{
                        id
                        name
                        exp_month
                        exp_year
                        object
                        type
                        created_at
                        last4
                        brand
                    }
                }`,
            addCard: gql`
                mutation AddCard($card: ConektaCard!, $phone: String, $email: String){
                    addCard(card: $card, phone: $phone, email: $email){
                        id
                        name
                        exp_month
                        exp_year
                        object
                        type
                        created_at
                        last4
                        brand
                    }
                }`,
            removeCard: gql`
                mutation RemoveCard($paymentId: String!){
                    removeCard(paymentId: $paymentId){
                        id
                        name
                        exp_month
                        exp_year
                        object
                        type
                        created_at
                        last4
                        brand
                    }

                }`,
        }
    }
}